<template>
  <div>
    <div
        v-if="notificationLoading"
        style="
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        padding-top: 25%;
        background-color: rgba(255, 255, 255, 0.31);
      "
    >
      <div class="text-xs-center">
        <v-progress-circular
            :size="70"
            :width="7"
            indeterminate
            color="#ff9233"
            class="text-xs-center my-5"
            large
        ></v-progress-circular>
      </div>
    </div>
    <v-container fluid grid-list-md class="padding_10" v-else>

      <v-layout row wrap>
        <v-flex xs12 sm12 md12 lg9>
          <v-expansion-panel class="mb-4">
            <v-expansion-panel-content>
              <template v-slot:header>
                <div>Filters</div>
              </template>
              <v-layout row wrap style="padding: 0px 10px 0px 10px; align-content: center; align-items: center;"
                        class="index_header">
                <v-flex sm4 md2 lg2 style="margin-top: -10px">
                  <v-checkbox
                      label="Draft"
                      :value="filters.Draft"
                      row
                      v-model="filters.Draft"
                      @change="filter($event)"
                      class="request_checkbox"
                      :color="'black'"></v-checkbox>
                </v-flex>
                <v-flex sm4 md2 lg3 style="margin-right: -14px; margin-top: -10px">
                  <v-checkbox
                      label="Published"
                      :value="filters.Published"
                      v-model="filters.Published"
                      @change="filterPublished($event)"
                      class="request_checkbox"
                      :color="'black'"
                  ></v-checkbox>
                </v-flex>

                <v-flex sm4 md2 lg2 style="margin-top: -10px; margin-right: 20px;">
                  <v-checkbox
                      label="Archived"
                      :value="filters.Archived"
                      v-model="filters.Archived"
                      @change="filterArchived($event)"
                      class="request_checkbox"
                      :color="'black'" solo flat
                  ></v-checkbox>
                </v-flex>

                <!--                <v-flex sm4 md2 lg2 style="margin-right: -10px; margin-top: -10px">-->
                <!--                  <v-checkbox-->
                <!--                      label="Is-Pinned"-->
                <!--                      :value="filters.Is_pinned"-->
                <!--                      v-model="filters.Is_pinned"-->
                <!--                      @change="filterIsPinned($event)"-->
                <!--                      class="request_checkbox"-->
                <!--                      :color="'black'"-->
                <!--                  ></v-checkbox>-->
                <!--                </v-flex>-->

                <v-flex sm12 md6 lg4 style="margin-top: 5px">
                  <v-autocomplete
                      v-model="filters.title"
                      placeholder="Search By Title"
                      :search-input.sync="search_title" solo flat
                      :items="title_list"
                      item-value="title"
                      item-text="title"
                      clearable
                      @change="searchByTitle()"
                  ></v-autocomplete>
                </v-flex>

              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>

        <v-flex xs12 sm12 md12 lg3>
          <v-flex sm12 md12 lg12 style="display: flex; justify-content: center; padding-bottom: 15px; margin-top:-7px;">
            <v-btn slot="activator" large class="white--text add_announcement" style="width: 80%;">
              <router-link to="/news/create" class="white--text">
                <v-icon color="#bbbbc6" class="white--text mr-2">edit</v-icon>
                Create News
              </router-link
              >
            </v-btn>
          </v-flex>
        </v-flex>
      </v-layout>

      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12>
          <v-data-table
              no-results-text="Loading... Please wait"
              :headers="headers"
              v-model="selected"
              :items="commute_list"
              item-key="id"
              :loading="loaders.office_list_loader"
              :total-items="total_items"
              :pagination.sync="pagination"
              :rows-per-page-items="[10, 20, 50, 100]"
          >
            <!--            <template v-slot:headers="props">-->
            <!--              <tr>-->
            <!--                <th style="padding: 0 10px">-->
            <!--                  &lt;!&ndash; <v-checkbox-->
            <!--					            :input-value="props.all"-->
            <!--					            :indeterminate="props.indeterminate"-->
            <!--					            primary-->
            <!--					            hide-details-->
            <!--					            @click.stop="toggleAll"-->
            <!--					        >-->
            <!--					        	<template v-slot:append>-->
            <!--					        		<div >-->
            <!--					        			<v-menu offset-y>-->
            <!--							                <v-icon slot="activator">arrow_drop_down</v-icon>-->
            <!--							            <v-list>-->
            <!--							                <v-list-tile >-->
            <!--							                  <v-list-tile-title style="cursor:pointer;" @click="pageSelect" class="mr-1">Select This Page</v-list-tile-title>-->
            <!--							                  <v-icon color="primary" small v-if="!is_selected_all" style="float: right;">check</v-icon>-->
            <!--							                </v-list-tile>-->
            <!--							                <v-list-tile >-->
            <!--							                  <v-list-tile-title style="cursor:pointer;" @click="togglePages" class="mr-1">Select All</v-list-tile-title>-->
            <!--							                  <v-icon color="primary" small v-if="is_selected_all" style="float: right;">check</v-icon>-->
            <!--							                </v-list-tile>-->
            <!--							                <v-list-tile >-->
            <!--							                  <v-list-tile-title style="cursor:pointer;" @click="deselectAll">Deselect All</v-list-tile-title>-->
            <!--							                </v-list-tile>     -->
            <!--							            </v-list>-->
            <!--					            </v-menu>  -->
            <!--					        		</div>-->
            <!--					        	</template>-->
            <!--					        </v-checkbox> &ndash;&gt;-->

            <!--                </th>-->

            <!--              </tr>-->
            <!--            </template>-->
            <!--            slot="items" slot-scope="props"-->
            <template v-slot:items="props">

              <!--              <td style="padding: 0 10px">-->
              <!--                <v-checkbox-->
              <!--                    v-model="props.selected"-->
              <!--                    primary-->
              <!--                    hide-details-->
              <!--                    :readonly="is_selected_all"-->
              <!--                ></v-checkbox>-->
              <!--              </td>-->

              <!--              <td>-->
              <!--                <v-checkbox-->
              <!--                    :on-icon="'star'"-->
              <!--                    :off-icon="'star'"-->
              <!--                    v-model="props.item.is_pinned"-->
              <!--                    :color="props.item.is_pinned == 1 ? 'orange' : 'red'"-->
              <!--                    @change="updatePinStatus(props.item.is_pinned, props.item.id)">-->
              <!--                </v-checkbox>-->
              <!--              </td>-->

              <td>
                <router-link :to="{name:'newsDetail',params:{id:props.item.id } }">
                  {{ props.item.title }}
                </router-link>
              </td>
              <td>
                <span v-if="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm || $vuetify.breakpoint.md">
              {{ props.item.description.substring(0, 40) + "..." }}</span>
                <span v-else>{{ props.item.description }}</span>
              </td>

              <td v-if="props.item.source_name">
                {{ props.item.source_name }}
              </td>
              <td v-else> {{ "-" }}</td>

              <td v-if="props.item">
                {{ props.item.city_name }}
              </td>
              <td v-else> {{ " - " }}</td>

              <td style="text-transform: capitalize;">
                <v-chip style="width: 100%; display: flex;justify-content: space-around;"
                        v-if="props.item.status == 'draft'"
                        color="#FFEDAA" text-color="#935E0D">{{ props.item.status }}
                </v-chip>

                <v-chip style="margin: 0px; width: 100%; display: flex;justify-content: space-around;"
                        v-if="props.item.status == 'published'"
                        color="#C8E6C9" text-color="#1B5E20">{{ props.item.status }}
                </v-chip>

                <v-chip color="#d2b5a1" text-color="#794936" style="margin: 0px; width: 100%;
                display: flex;justify-content: space-around;" v-if="props.item.status == 'archived'"
                >{{ props.item.status }}
                </v-chip>

              </td>
              <td>
                {{ props.item.updated_at | appDateTimeFormat }}
              </td>
            </template>


          </v-data-table>
        </v-flex>
      </v-layout>

      <v-snackbar
          :timeout="snack_bar.timeout"
          :color="snack_bar.color"
          :top="snack_bar.top"
          :bottom="snack_bar.bottom"
          :left="snack_bar.left"
          :right="snack_bar.right"
          v-model="snack_bar.show"
      >
        {{ snack_bar.message }}
        <v-btn dark flat @click.native="snack_bar.show = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>
<script>
import {mapGetters} from "vuex";

export default {
  created() {
  },
  computed: {
    ...mapGetters({
      office_location: "get_office_location",
    }),
  },
  watch: {
    pagination: {
      handler() {
        this.getList();
      },
    },
    search_title: {
      handler(newVal) {
        if (newVal != null && newVal.length > 3) {
          this.getTitleList(newVal);
        }
      },
    },
    "filters.title": {
      handler(value) {
        if (value == undefined) {
          this.filters.title = "";
          this.getList();
        }
      },
    },
  },
  methods: {
    searchByTitle() {
      this.getList();
    },
    filter(value) {
      this.filters.Published = false;
      this.filters.Archived = false;
      this.filters.Draft = value;
      // this.filters.Is_pinned = false;
      this.getList();
    },
    filterPublished(value) {
      this.filters.Draft = false;
      this.filters.Archived = false;
      this.filters.Published = value;
      // this.filters.Is_pinned = false;
      this.getList();
    },
    filterArchived(value) {
      this.filters.Published = false;
      this.filters.Draft = false;
      this.filters.Archived = value;
      // this.filters.Is_pinned = false;
      this.getList();
    },

    // filterIsPinned(value) {
    //   this.filters.Published = false;
    //   this.filters.Draft = false;
    //   this.filters.Archived = false;
    //   // this.filters.Is_pinned = value;
    //   this.getList();
    // },
    getList: function () {
      this.loaders.office_list_loader = true;
      this.pagination.filters = Object.assign({}, this.filters);
      axios
          .get(`${process.env.VUE_APP_API_URL}/api/v1/commute-news-web`, {
            params: this.pagination,
            headers: this.$headers
          })
          .then((response) => {
            if (response.data.status == 1) {
              // console.log(response)
              this.commute_list = response.data.news.data;

              if (this.cityList && this.cityList.length > 0) {
                this.commute_list.forEach((commute) => {
                  let city = this.cityList.find(item => item.id == commute.city_id);

                  if (city) {
                    commute.city_name = city.name;
                  }
                });
              }
              this.total_items = response.data.news.total;
            }
          })
          .catch((error) => {
            console.log(error);
            this.snack_bar.message = "Error Occured";
            this.snack_bar.show;
          })
          .finally(() => {
            {
              this.loaders.office_list_loader = false;
            }
          });

      this.is_loading = false;
    },

    clearFilter: function (filter, key) {
      this.filter_chips[key] = this.filters[key] = "";
      this.filterList();
    },
    resetFilter() {
      this.$router.replace({
        name: "offices",
        query: {},
      });
      this.getList();
      this.resetFiltersParameters();
      this.is_filtered = false;
      this.filter_dialog_box = false;
      // this.snack_bar.message = "Filter Reset.";
      // this.snack_bar.show = true;
    },
    resetFiltersParameters: function () {
      for (var key in this.filters) {
        this.filters[key] = "";
        this.filter_chips[key] = "";
      }
    },
    applyFiltersOnLoad: function () {
      this.filters.name = this.$route.query.name;
      this.filters.address = this.$route.query.address;
      this.displayFilterChips(this.filters);
    },
    displayFilterChips: function (filters) {
      if (this.$route.query.filters) {
        this.filter_chips.name = filters.name;
        this.filter_chips.address = filters.address;
        this.is_filtered = true;
      }
    },
    validateBeforeSubmit: function (scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this[scope]();
        }
      });
    },
    toggleAll() {
      if (this.selected.length) {
        this.selected = [];
      } else {
        this.selected = this.commute_list.slice();
      }
      this.is_selected_all = false;
    },
    togglePages() {
      this.is_selected_all = !this.is_selected_all;
      if (this.is_selected_all) {
        this.selectAll();
        this.all_selected_items = [];
      } else {
        this.selected = [];
      }
    },
    selectAll() {
      this.selected = this.commute_list.slice();
    },

    pageSelect() {
      this.toggleAll();
    },
    deselectAll() {
      this.selected = [];
      this.is_selected_all = false;
      this.all_selected_items = [];
    },
    getTitleList: function (newVal) {
      this.loaders.office_list_loader = true;
      axios
          .get(
              `${process.env.VUE_APP_API_URL}/api/v1/commute-news-title-filter`,
              {headers: this.$headers, params: {searched_title: newVal}}
          )
          .then((response) => {
            if (response.data.status == 1) {
              this.title_list = response.data.titles;
            }
          })
          .catch((error) => {
            console.log(error);
            this.snack_bar.message = "Error Occurred";
            this.snack_bar.show = true;
          })
          .finally(() => {
            {
              this.loaders.office_list_loader = false;
            }
          });
      this.is_loading = false;
    },
    getCityList() {
      axios
          .get(`${process.env.VUE_APP_API_URL}/api/v1/get-city-list`, {headers: this.$headers})
          .then(response => {
            if (response.data.status == 1) {
              this.cityList = response.data.data;
              this.cityList.push({'id': 0, 'name': "ALL"})
            }
          });
    }
    // updatePinStatus(status, id) {
    //   axios
    //       .post(
    //           `${process.env.VUE_APP_API_URL}/api/v1/pinned-commuteNews`,
    //           {commute_news_id: id, status: status}, {headers: this.$headers}
    //       ).then((response) => {
    //     if (response.data.status == 1) {
    //       this.commute_list = [];
    //       this.getList();
    //     } else if (response.data.status == 0) {
    //       this.snack_bar.message = response.data.message;
    //       this.snack_bar.show = true;
    //     }
    //   }).catch((error) => {
    //     this.snack_bar.message = "Error Occurred";
    //     this.snack_bar.show = true;
    //   })
    // }
  },
  data: () => {
    return {
      announcement_item: {},
      title_list: [],
      search_title: "",
      delete_model: false,
      is_selected_all: false,
      all_selected_items: [],
      selected: [],
      is_filtered: false,
      notificationLoading: false,
      filter_key_count: -1,
      pagination: {sortBy: "updated_at", descending: true, rowsPerPage: 10},
      filters: {
        status: "",
        title: "",
        Draft: false,
        Published: false,
        Archived: false,
        // Is_pinned: false,
      },
      filter_chips: {
        name: "",
        address: "",
      },
      filter_dialog_box: false,
      snack_bar: {
        show: false,
        message: "",
        timeout: 4000,
        top: true,
        right: true,
        bottom: false,
        left: false,
        color: "",
      },
      total_items: 0,
      headers: [

        {
          text: "Title",
          value: "title",
          align: "left",
          sortable: false,
        },
        {
          text: "Description",
          value: "description",
          align: "left",
          sortable: false,
        },
        {
          text: "Source",
          value: "source_name",
          align: "left",
          sortable: false,
        },
        {
          text: "City Name",
          value: "city_name",
          align: "left",
          sortable: false,
        },
        {
          text: "Status",
          value: "status",
          sortable: false,
        },
        {
          text: "Updated At",
          value: "updated_at",
          sortable: true,
        },
      ],
      commute_list: [],
      add_new_office_model: false,
      new_office: {
        name: "",
      },
      loaders: {
        office_list_loader: false,
        new_office_submit_loader: false,
      },
      auth_user: {
        roles: [{}],
      },
      selectedID: '',
      cityList: [],
    };
  },
  mounted() {
    this.getCityList();
    this.getList();
    this.applyFiltersOnLoad();
    this.auth_user = this.$store.getters.get_user;
    // console.log(this.auth_user)
  },
};
</script>


<style>
.add_announcement {
  background: linear-gradient(90deg, #ff5e5c 0%, #ff9233 100%);

}
</style>

